import type { HeroSlide } from "@/types/media";

export const heroSlides: HeroSlide[] = [
  {
    id: "hero-01",
    mediaId: "tiexue-yuanzheng",
    title: "铁血远征",
    subtitle: "风雪战场上的坚守，一段不能被遗忘的历史",
    tag: "年度战争巨制",
    image:
      "https://readdy.ai/api/search-image?query=Grand%20war%20epic%20battlefield%20panorama%20at%20dawn%2C%20marching%20army%20silhouettes%20on%20snowy%20plain%2C%20glowing%20amber%20sunrise%20over%20distant%20mountains%2C%20dramatic%20cinematic%20wide%20film%20still&width=1600&height=900&seq=tangxin-hero-01&orientation=landscape",
    link: "/detail/tiexue-yuanzheng",
  },
  {
    id: "hero-02",
    mediaId: "changfeng-dukou",
    title: "长风渡口",
    subtitle: "一条江，二十年，写尽时代洪流下的众生",
    tag: "高分年代大剧",
    image:
      "https://readdy.ai/api/search-image?query=Epic%20historical%20riverside%20town%20panorama%20at%20golden%20dusk%2C%20misty%20river%20and%20ancient%20boats%2C%20sweeping%20cinematic%20wide%20shot%20with%20dramatic%20amber%20sky&width=1600&height=900&seq=tangxin-hero-02&orientation=landscape",
    link: "/detail/changfeng-dukou",
  },
  {
    id: "hero-03",
    mediaId: "xinghe-bian",
    title: "星河彼岸",
    subtitle: "隔着数百光年，也要把思念送到你身边",
    tag: "科幻爱情新作",
    image:
      "https://readdy.ai/api/search-image?query=Epic%20wide%20shot%20of%20a%20glowing%20planet%20and%20starship%20silhouette%2C%20cosmic%20nebula%20in%20gold%20and%20indigo%2C%20cinematic%20science%20fiction%20film%20still&width=1600&height=900&seq=tangxin-hero-03&orientation=landscape",
    link: "/detail/xinghe-bian",
  },
  {
    id: "hero-04",
    mediaId: "wudu-mian",
    title: "雾都迷案",
    subtitle: "当所有人都可能是敌人，真相藏在雾的尽头",
    tag: "悬疑口碑之作",
    image:
      "https://readdy.ai/api/search-image?query=Moody%20foggy%20night%20city%20street%20with%20lone%20detective%20silhouette%2C%20teal%20mist%20and%20warm%20amber%20streetlamp%20glow%2C%20crime%20thriller%20film%20noir%20wide%20still&width=1600&height=900&seq=tangxin-hero-04&orientation=landscape",
    link: "/detail/wudu-mian",
  },
  {
    id: "hero-05",
    mediaId: "xingyu-shaonian",
    title: "星屿少年",
    subtitle: "在星光熄灭之前，出发去寻找最亮的那一颗",
    tag: "治愈系动画",
    image:
      "https://readdy.ai/api/search-image?query=Whimsical%20animated%20floating%20island%20under%20starry%20night%20sky%20with%20glowing%20island%20sea%2C%20teal%20ocean%20and%20golden%20stars%2C%20hand-painted%20anime%20wide%20film%20still&width=1600&height=900&seq=tangxin-hero-05&orientation=landscape",
    link: "/detail/xingyu-shaonian",
  },
];